import React, { useState } from 'react';
import { Box, Typography, TextField, InputAdornment, Grid } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux'; // For global state management if needed

const HeroBanner = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');

    // Handle the search term change
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        onSearch(event.target.value); // Pass the search term to the parent component
    };

    return (
        <Box
            sx={{
                height: '40vh',
                backgroundColor: '#000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Grid container sx={{ maxWidth: '100vw', px: '4vw' }}>
                <Grid item md={8} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 'bold',
                            color: 'white',
                            mb: '2vh',
                        }}
                    >
                        Find Solutions
                    </Typography>

                    <TextField
                        value={searchTerm}
                        onChange={handleSearchChange}
                        placeholder="Search the community"
                        variant="outlined"
                        fullWidth
                        sx={{
                            backgroundColor: '#333',
                            borderRadius: '8px',
                            input: { color: 'white' },
                            maxWidth: '500px',
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: '#bbb' }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                {/* Right Side - Image */}
                <Grid
                    item
                    md={4}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        component="img"
                        src="/Banner/BannerDiscussion.png"
                        alt="People working"
                        sx={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '40vh',
                            objectFit: 'cover',
                            marginTop: '3.5vh',
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default HeroBanner;
